// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/abnormal-combustion.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/abnormal-combustion/abnormal-combustion.js';

mount([g0]);
